import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'

import Button from 'discada/dist/Button'

import { TradePendingReportNew } from 'components/Quote/TradePendingReport'
import { TradePendingSearchNew } from 'components/Quote/TradePendingSearch'
import { getPermission } from 'selectors/authSelectors'

import QV from 'components/Quote/QuoteValue'
import { addItem, removeItem, changeQuote } from 'actions/quoteActions'
import { getQuoteValue } from 'selectors/quoteSelectors'
import { getRooftopWebsite, getTPDealerID } from 'selectors/appStatusSelectors'

import { updateTrade, addTrade, removeTrade } from 'actions/naughtyActions'
import { hydrateCustomer } from 'actions/appStatusActions'

import {
  getCustomerZip,
  getCustomerName,
  getCustomerTrades,
  getCustomerHasNoTrade,
} from 'selectors/naughtySelectors'

import { initialTrade } from 'reducers/quoteReducers'
import { ReactionSection } from 'components/widgets/Reactions/ReactionSection'
import {
  getRawEquity as getEquity,
  getTradeShortLabel,
  getEquityContent,
  isTradeValueOk,
} from 'utils/trade'

import { moneyShort } from 'utils'

import VehicleImage from 'components/widgets/VehicleImage'

import './Trades.scss'

export const MODES = {
  search: 'search',
  values: 'values',
}

export class Trade extends React.Component {
  state = {
    visible: false,
    mode:
      get(this.props.trade, 'id') && isTradeValueOk(this.props.trade)
        ? MODES.values
        : MODES.search,
  }

  componentDidMount() {
    setTimeout(() => this.setState({ visible: true }), 100)
  }

  render() {
    let {
        vehicleId,
        quoteId,
        className,
        trade,
        tradeIndex,
        showAdd,
        showRemove,
        showAcv,
        tradeKey,
        noTrade,
        changeQuote,
        updateTrade,
        firstName,
        createChangeEvent,
        hydrateCustomer = () => {},
        addItem = () => {},
        removeItem = () => {},
        addTrade = () => {},
        removeTrade = () => {},
        onChange = () => {},
      } = this.props,
      tradeHeader = getTradeShortLabel(trade),
      tpVehicle = get(trade, 'tradePending.vehicle', {}),
      allowanceContent = getEquityContent(trade),
      equityValue = getEquity(trade),
      { visible, mode } = this.state,
      setNoTrade = () => {
        this.setState({ mode: MODES.search })
        hydrateCustomer({ hasNoTrade: !noTrade }, { createChangeEvent })

        vehicleId && quoteId && changeQuote(vehicleId, quoteId, { trades: [] })
      },
      toggleMode = () => {
        let currentMode = this.state.mode,
          mode = currentMode === MODES.values ? MODES.search : MODES.values

        this.setState({ mode })
      },
      valueRenderer = (v, options = {}) => (
        <React.Fragment key={v.valueKey}>
          {v.control}
          {!v.noValue && !v.hide && (
            <QV
              vehicleId={vehicleId}
              quoteId={quoteId}
              k={v.valueKey ? `trades[${tradeIndex}].${v.valueKey}` : null}
              label={v.label}
              value={v.value || null}
              className={c('trade-input-field reset', options.className)}
              type={v.type}
              readOnly={v.readOnly || noTrade}
              permit={v.permit}
              inputProps={{
                rounded: true,
                rightIcon: v.rightIcon,
              }}
              onAfterChange={x => {
                updateTrade(
                  tradeIndex,
                  { [v.valueKey]: x },
                  { createChangeEvent },
                )
                onChange(tradeIndex, v.valueKey, x)
              }}
            />
          )}
        </React.Fragment>
      ),
      valueFields = {
        allowance: {
          label: (
            <>
              Est. <strong>Value</strong>
            </>
          ),
          valueKey: 'allowance',
          type: 'moneyShort',
          permit: 'customize',
          size: 'small',
          rightIcon: 'hand-pointer',
          className: 'reset',
        },
        residual: {
          label: <strong>Residual?</strong>,
          valueKey: 'residual',
          type: 'moneyShort',
          size: 'small',
          permit: 'customize',
          rightIcon: 'hand-pointer',
        },
        payoff: {
          label: trade.isLease ? (
            <>
              Total <strong>Left to Pay?</strong>
            </>
          ) : (
            <>
              What do you <strong>Owe?</strong>
            </>
          ),
          valueKey: 'payoff',
          type: 'moneyShort',
          permit: 'customize',
          size: 'small',
          rightIcon: 'hand-pointer',
        },
        mileage: {
          label: 'Est. Mileage',
          valueKey: 'mileage',
          type: 'number',
          permit: 'customize',
          rightIcon: 'tachometer-alt',
        },
        acv: {
          label: 'ACV',
          valueKey: 'acv',
          type: 'moneyShort',
          className: 'internal acv',
          hide: !showAcv,
          size: 'small',
          rightIcon: 'cog',
        },
      }

    return (
      <ReactionSection
        className={c(
          'trade-input',
          `trade-input-${tradeKey}`,
          'snap-typeahead',
          className,
          { 'trade-selected': !!tpVehicle.ymmt, visible },
        )}
      >
        <div className="tp-fields border">
          {mode === MODES.values && (
            <h3>
              {firstName && <strong>{firstName}! </strong>} It's time to upgrade
              your{' '}
              <strong>{isEmpty(tradeHeader) ? 'car' : tradeHeader}!</strong>
            </h3>
          )}

          {mode === MODES.search && (
            <h3>
              {firstName && <strong>{firstName}! </strong>} Your vehicle's value
              can change daily!
              <small>
                Confirm your trade information to get the{' '}
                <strong>most up-to-date value</strong>!
              </small>
            </h3>
          )}

          {!noTrade && (
            <div className="tp-fields-inner">
              <VehicleImage {...trade} className="tp-values-report">
                <TradePendingReportNew
                  createChangeEvent={createChangeEvent}
                  vehicleId={vehicleId}
                  quoteId={quoteId}
                  tradeIndex={tradeIndex}
                  tradeKey={tradeKey}
                  toggleMode={toggleMode}
                  mode={mode}
                />
              </VehicleImage>

              <div className="tp-user-inputs">
                {mode === MODES.search ? (
                  <TradePendingSearchNew
                    createChangeEvent={createChangeEvent}
                    vehicleId={vehicleId}
                    quoteId={quoteId}
                    tradeIndex={tradeIndex}
                    tradeKey={tradeKey}
                  >
                    <Button
                      success
                      rounded
                      className="trade-submit-control link"
                      tabIndex="-1"
                      size="small"
                      icon="hand-pointer"
                      disabled={!trade.id || !trade.mileage}
                      onClick={() => {
                        updateTrade(
                          tradeIndex,
                          { confirmed: new Date().getTime() },
                          { createChangeEvent: true },
                        )
                        this.setState({ mode: MODES.values })
                      }}
                    >
                      That's my car! What's it worth?
                    </Button>
                    {tradeIndex === 0 && (
                      <Button
                        text
                        size="small"
                        className="no-trades-control"
                        onClick={setNoTrade}
                      >
                        I don't have a trade
                      </Button>
                    )}
                    {tradeIndex !== 0 && (
                      <Button
                        text
                        tabIndex="-1"
                        size="small"
                        className="list-control"
                        onClick={() => {
                          !createChangeEvent
                            ? removeItem(
                                vehicleId,
                                quoteId,
                                tradeIndex,
                                'trades',
                                true,
                              )
                            : removeTrade(tradeIndex, { createChangeEvent })
                        }}
                      >
                        Remove Trade
                      </Button>
                    )}
                  </TradePendingSearchNew>
                ) : (
                  <div className="trade-value-field-wrapper">
                    <div className="trade-value-fields">
                      {valueRenderer(valueFields.allowance)}
                      <div className="equity-math-symbol">
                        <small>&nbsp;</small>-
                      </div>
                      {valueRenderer(valueFields.payoff)}
                      {trade.isLease && (
                        <>
                          <div className="equity-math-symbol">
                            <small>&nbsp;</small>-
                          </div>
                          {valueRenderer(valueFields.residual)}
                        </>
                      )}
                    </div>
                    {allowanceContent && (
                      <p className="trade-allowance-content">
                        {allowanceContent}
                      </p>
                    )}
                    <div className="trade-controls">
                      <Button
                        text
                        tabIndex="-1"
                        size="small"
                        className="list-control link"
                        onClick={() => {
                          !createChangeEvent
                            ? removeItem(
                                vehicleId,
                                quoteId,
                                tradeIndex,
                                'trades',
                                true,
                              )
                            : removeTrade(tradeIndex, { createChangeEvent })
                        }}
                      >
                        Remove
                      </Button>
                      <Button
                        text
                        className="list-control link"
                        onClick={() => {
                          updateTrade(
                            tradeIndex,
                            { confirmed: 0, tradePending: null },
                            { createChangeEvent: true },
                          )

                          this.setState({ mode: MODES.search })
                        }}
                      >
                        Not Your Car?
                      </Button>
                      <Button
                        text
                        className="list-control link"
                        onClick={() => {
                          updateTrade(
                            tradeIndex,
                            {
                              isLease: !trade.isLease,
                              residual: 0,
                            },
                            { createChangeEvent: true },
                          )
                        }}
                      >
                        <input
                          style={{ height: '12px' }}
                          type="checkbox"
                          checked={trade.isLease}
                        />{' '}
                        Leased?
                      </Button>
                      {showAdd && (
                        <Button
                          text
                          size="small"
                          className="list-control link"
                          onClick={() => {
                            !createChangeEvent
                              ? addItem(
                                  vehicleId,
                                  quoteId,
                                  'trades',
                                  null,
                                  true,
                                )
                              : addTrade({ createChangeEvent })
                          }}
                        >
                          Add Another
                        </Button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </ReactionSection>
    )
  }
}

export function Trades(props) {
  let {
      trades,
      noTrade,
      vehicleId,
      quoteId,
      createChangeEvent,
      addItem,
      addTrade,
    } = props,
    addTradeButon = (
      <div className="add-trade-button">
        <Button
          primary
          size="small"
          icon="plus"
          onClick={() => {
            !createChangeEvent
              ? addItem(vehicleId, quoteId, 'trades', null, true)
              : addTrade({ createChangeEvent })
          }}
        >
          Add A Trade
        </Button>
      </div>
    )

  if (isEmpty(trades)) trades = [initialTrade]

  return (
    <>
      {trades.map((t, i) => (
        <Trade
          {...props}
          trade={t}
          tradeIndex={i}
          key={i}
          tradeKey={t.key || i}
          showAdd={i + 1 === trades.length}
          showRemove={trades.length > 1}
        />
      ))}
      {noTrade && addTradeButon}
    </>
  )
}

function mapStateToProps(state, op) {
  return {
    ...op,
    noTrade: getCustomerHasNoTrade(state),
    trades: getQuoteValue(state, op.vehicleId, op.quoteId, 'trades', []),
    internal: getPermission(state, 'deal.fields/profit'),
    zipCode: getCustomerZip(state),
    tpDealerId: getTPDealerID(state),
    firstName: getCustomerName(state)[0],
    dealerWebsite: getRooftopWebsite(state),
  }
}

function mapSqueezeJacketStateToProps(state, op) {
  return {
    ...op,
    createChangeEvent: true,
    noTrade: getCustomerHasNoTrade(state),
    trades: getCustomerTrades(state),
    zipCode: getCustomerZip(state),
    tpDealerId: getTPDealerID(state),
    firstName: getCustomerName(state)[0],
    dealerWebsite: getRooftopWebsite(state),
  }
}

export default connect(
  mapStateToProps,
  {
    addItem,
    updateTrade,
    removeItem,
    removeTrade,
    addTrade,
    hydrateCustomer,
    changeQuote,
  },
)(Trades)

export const SqueezeTrades = connect(
  mapSqueezeJacketStateToProps,
  {
    addItem,
    updateTrade,
    removeItem,
    removeTrade,
    addTrade,
    hydrateCustomer,
    changeQuote,
  },
)(Trades)
